import { Message, MessageStatus } from "@screencloud/screencloud-ui-components";
import { type InjectedIntlProps, injectIntl } from "react-intl";

export interface ShippingWarningProps {
  /** The selected shipping country's display name, shown in the title. */
  countryName: string;
}

/**
 * Alert shown when the selected shipping country is not supported for hardware
 * shipping. Self-contained: give it a country name and it renders the localized
 * warning, so the unsupported-country case can be tested without the whole step.
 */
function ShippingWarningBase({
  countryName,
  intl,
}: ShippingWarningProps & InjectedIntlProps) {
  return (
    <div data-testid="shipping-unsupported-warning">
      <Message
        status={MessageStatus.WARNING}
        icon="warning"
        title={intl.formatMessage(
          {
            id: "pixi_wizard.payment_shipping.warning.title",
            defaultMessage: "We don't ship hardware to {country}",
          },
          { country: countryName },
        )}
        description={intl.formatMessage({
          id: "pixi_wizard.payment_shipping.warning.description",
          defaultMessage:
            "Unfortunately, we currently do not ship to this country. Please provide an address from the supported countries below.",
        })}
      />
    </div>
  );
}

export const ShippingWarning = injectIntl(ShippingWarningBase);
